//import Promotions from "@tw/customer-identity-cra/lib/home/home-master-nextjs";
import Promotions from "@tw/customer-identity-cra/lib/promotions/promotions-master-nextjs";
import PageWrapper from "../../wrappers/page-wrapper";

Promotions.domainName = "customer-identity";

export default PageWrapper(Promotions);